// Importy modułów Swiper
const { Navigation, Pagination, Autoplay, EffectFade } = window;

// Rejestracja modułów globalnie dla Swiper (tylko te dostępne)
if (window.Swiper) {
    const mods = [];
    if (window.SwiperNavigation) mods.push(window.SwiperNavigation);
    if (window.SwiperPagination) mods.push(window.SwiperPagination);
    if (window.SwiperAutoplay) mods.push(window.SwiperAutoplay);
    if (window.SwiperEffectFade) mods.push(window.SwiperEffectFade);
    if (mods.length) window.Swiper.use(mods);
}



// var swiper = new Swiper(".specjalizacjeSwiper", {
//   grabCursor: false,
//   simulateTouch: false,
//   slidesPerView: 3,
//   spaceBetween: 16,
//   loop: true,
//   navigation: {
//       nextEl: ".specjalizacjeSwiper-next",
//       prevEl: ".specjalizacjeSwiper-prev",
//     },
// });

var swiper = new Swiper(".specialistsSwiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
        nextEl: ".specialistsSwiper-button-next",
        prevEl: ".specialistsSwiper-button-prev",
    },
    pagination: {
        el: ".specialistsSwiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        420: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        500: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
    },
});

var swiper = new Swiper(".fieldsSwiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    autoplay: {
        delay: 5000,

    },
    navigation: {
        nextEl: ".fieldsSwiper-button-next",
        prevEl: ".fieldsSwiper-button-prev",
    },
    pagination: {
        el: ".fieldsSwiper-pagination",
        clickable: true,
    },
    breakpoints: {
        420: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        500: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
    },
});


var swiper = new Swiper(".reviewsSwiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    navigation: {
        nextEl: ".reviewsSwiper-button-next",
        prevEl: ".reviewsSwiper-button-prev",
    },
    pagination: {
        el: ".reviewsSwiper-pagination",
        clickable: true,
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 32,
        },
    },
});

function initReviewReadMoreModal() {
    const MODAL_ID = 'review-read-more-modal';
    const reviewItems = document.querySelectorAll('.review-item');

    if (!reviewItems.length) {
        return;
    }

    let modal = document.getElementById(MODAL_ID);
    if (!modal) {
        modal = document.createElement('div');
        modal.id = MODAL_ID;
        modal.className = 'review-modal';
        modal.setAttribute('hidden', 'hidden');
        modal.innerHTML = [
            '<div class="review-modal__backdrop js-review-modal-close"></div>',
            '<div class="review-modal__dialog" role="dialog" aria-modal="true" aria-label="Pelna tresc opinii">',
            '<button type="button" class="review-modal__close js-review-modal-close" aria-label="Zamknij">x</button>',
            '<div class="review-modal__content js-review-modal-content"></div>',
            '</div>'
        ].join('');
        document.body.appendChild(modal);
    }

    const modalContent = modal.querySelector('.js-review-modal-content');
    const closeModal = () => {
        modal.setAttribute('hidden', 'hidden');
        document.body.classList.remove('review-modal-open');
        if (modalContent) {
            modalContent.innerHTML = '';
        }
    };

    modal.querySelectorAll('.js-review-modal-close').forEach((node) => {
        if (node.dataset.modalCloseReady === '1') {
            return;
        }
        node.addEventListener('click', closeModal);
        node.dataset.modalCloseReady = '1';
    });

    if (modal.dataset.escReady !== '1') {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
                closeModal();
            }
        });
        modal.dataset.escReady = '1';
    }

    reviewItems.forEach((item) => {
        const content = item.querySelector('.js-review-content');
        const toggle = item.querySelector('.js-review-toggle');

        if (!content || !toggle) {
            return;
        }

        if (item.dataset.toggleReady !== '1') {
            toggle.addEventListener('click', () => {
                if (!modalContent) {
                    return;
                }
                modalContent.innerHTML = content.innerHTML;
                modal.removeAttribute('hidden');
                document.body.classList.add('review-modal-open');
            });
            item.dataset.toggleReady = '1';
        }

        const prevDisplay = content.style.display;
        const prevClamp = content.style.webkitLineClamp;
        const prevOverflow = content.style.overflow;

        content.style.display = 'block';
        content.style.webkitLineClamp = 'unset';
        content.style.overflow = 'visible';

        const fullHeight = content.scrollHeight;

        content.style.display = prevDisplay;
        content.style.webkitLineClamp = prevClamp;
        content.style.overflow = prevOverflow;

        const normalizedFullHeight = Math.floor(fullHeight);
        const canReadMore = normalizedFullHeight > 140;
        toggle.hidden = !canReadMore;
        toggle.textContent = 'Czytaj więcej';
        toggle.setAttribute('aria-haspopup', 'dialog');
    });
}

document.addEventListener('DOMContentLoaded', initReviewReadMoreModal);
window.addEventListener('resize', initReviewReadMoreModal);


var swiper = new Swiper(".newestPostsSwiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
        nextEl: ".newestPostsSwiper-button-next",
        prevEl: ".newestPostsSwiper-button-prev",
    },
    pagination: {
        el: ".newestPostsSwiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 5000,
    },
    breakpoints: {
        320: {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 32,
        },
    },
});


// $(function() {
//   $('.twentytwenty-init').twentytwenty({
//     orientation: 'vertical',
//     move_with_handle_only: true,
//   });
// })

